
import Vue, { PropType } from "vue";
import { AlertDestination } from "@/models";

import BaseInputForm from "@/components/BaseInputForm.vue";
import BaseArrayCheckbox from "@/components/BaseArrayCheckbox.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";
import { ValidationObserver } from "vee-validate";

type Option = {
  name: string;
  value: string;
  iconName: string;
};

export type DataType = {
  name: string;
  mailAddress: string;
  enabledAlerts: string[];
  enabledAlertOptions: Array<Option>;
};

export default Vue.extend({
  name: "AlertDestinationEditor",

  components: {
    BaseInputForm,
    BaseArrayCheckbox,
    BaseSubmitButton,
    BaseCancelButton,
    ValidationObserver
  },

  props: {
    alertDestination: Object as PropType<AlertDestination>,
  },

  data(): DataType {
    return {
      name: "",
      mailAddress: "",
      enabledAlerts: [],

      enabledAlertOptions: [
        {
          name: "長時間利用通知",
          value: "longStayAlert",
          iconName: "longStayAlert",
        },
        {
          name: "電池残量通知",
          value: "lowBatteryAlert",
          iconName: "lowBatteryAlert",
        },
        {
          name: "機器停止通知",
          value: "failureAlert",
          iconName: "failureAlert",
        },
      ],
    };
  },

  computed: {
    longStayAlertEnabled(): boolean {
      return this.enabledAlerts.includes("longStayAlert");
    },

    failureAlertEnabled(): boolean {
      return this.enabledAlerts.includes("failureAlert");
    },

    lowBatteryAlertEnabled(): boolean {
      return this.enabledAlerts.includes("lowBatteryAlert");
    },

    isEdited(): boolean {
      return (
        this.alertDestination.name !== this.name ||
        this.alertDestination.mailAddress != this.mailAddress ||
        this.alertDestination.longStayAlertEnabled !== this.longStayAlertEnabled ||
        this.alertDestination.failureAlertEnabled !== this.failureAlertEnabled ||
        this.alertDestination.lowBatteryAlertEnabled !== this.lowBatteryAlertEnabled
      );
    },

  },

  watch: {
    alertDestination: function(n: AlertDestination) {
      this.name = n.name || "";
      this.mailAddress = n.mailAddress || "";
      if (n.longStayAlertEnabled) {
        this.enabledAlerts.push("longStayAlert");
      }
      if (n.failureAlertEnabled) {
        this.enabledAlerts.push("failureAlert");
      }
      if (n.lowBatteryAlertEnabled) {
        this.enabledAlerts.push("lowBatteryAlert");
      }
    },
  },

  methods: {
    saveAlertDestination(): void {
      this.$emit(
        "save-alert-destination",
        new AlertDestination({
          name: this.name,
          mailAddress: this.mailAddress,
          longStayAlertEnabled: this.enabledAlerts.includes("longStayAlert"),
          failureAlertEnabled: this.enabledAlerts.includes("failureAlert"),
          lowBatteryAlertEnabled: this.enabledAlerts.includes("lowBatteryAlert"),
        }),
      );
    },
  },
});
